import * as eleaveTypes from 'projects/fortunebit-staffhub/src/eleave/services/typings/eleave-api.typings'
import { AfterViewChecked, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NgOption, NgSelectComponent } from '@ng-select/ng-select';
import { Subject, Subscription } from 'rxjs';
import * as moment from 'moment';
import { isEmpty } from 'class-validator';

@Component({
  selector: 'app-ngselect-month-leave-select',
  templateUrl: './ngselect-month-leave-select.component.html',
  styleUrls: ['./ngselect-month-leave-select.component.scss']
})

export class NgselectMonthLeaveSelectComponent implements OnInit, AfterViewChecked, OnDestroy {

  public monthLoading = false
  public metadata: NgOption
  public all_months: Array<any>
  public monthSubs: Subscription[] = []
  public monthSelected: Array<eleaveTypes.Months> = []
  monthInput$ = new Subject<string>()
  monthList: eleaveTypes.Months[] = []
  @ViewChild("monthSelect") public monthSelect: NgSelectComponent
  @Input('selectedMonth') public selectedMonth: Array<eleaveTypes.Months> = []
  @Input('removeSelected') public removeSelected = new EventEmitter<string>()
  @Output('selectedMonthOutput') public selectedMonthOutput = new EventEmitter<Array<eleaveTypes.Months>>()
  displayMonthsList = new EventEmitter<eleaveTypes.Months[]>()

  constructor() {
    this.getAllMonths()
  }

  ngOnInit(): void { }

  ngAfterViewChecked(): void {
    this.trackMonthSelected()
  }

  ngOnDestroy(): void {
    if (this.monthSubs.length > 0) {
      this.monthSubs.map(sub => {
        sub.unsubscribe()
      })
    }
  }

  getAllMonths() {
    this.all_months = moment.months()
    this.monthList = this.all_months
  }

  dataInterceptor(data: string) {
    // console.log({ data });
    this.monthSelected.pop()
    if (!isEmpty(data)) {
      this.monthSelected.push({
        selectedMonth: data,
        metadata: this.metadata
      })
    } else {
      this.monthSelected = [{
        selectedMonth: ""
      }]
    }
    return this.monthSelected
  }

  trackMonthSelected() {
    this.monthSubs.push(this.monthSelect.changeEvent.subscribe(month => {
      // console.log({ month });
      month === undefined ? month = "" : month
      this.selectedMonthOutput.emit(this.dataInterceptor(month))
    }))
  }

  clearAll() {
    this.monthSelect.clearModel()
  }

}
